import React, { useState, useEffect } from "react";
import { getProductsF } from "../auth/apiProduct";
import Slider from '../slider/swiperProduct'

const NewProduct = ({
    laguangeElakay,
    infoSource,
    readUser,
    showB
}) => {
    const [productsByArrival, setProductsByArrival] = useState([]); 
    const filters = React.useMemo(() => ({}), []);

    const loadProductsByArrival = (skip, limit, selectedFilters) => {
        getProductsF(skip, limit, "createdAt", { filters: selectedFilters })
            .then(data => {
                setProductsByArrival(Array.isArray(data?.products) ? data.products.filter(Boolean) : []);
            })
            .catch(() => setProductsByArrival([]));
    };

    useEffect(() => {
        loadProductsByArrival(0, 50, filters);
        // `filters` est stable et ce chargement ne doit se faire qu'au montage.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filters])

    let myStyles = {
        width: "100%",
        backgroundColor: '#f0f0f0'
    }

    return (
        <Slider
            laguangeElakay={laguangeElakay}
            infoSource ={infoSource}
            ProductSwiper={productsByArrival}
            User={readUser}
            nameSlider={infoSource?.laguangeElakay?.('homePage', infoSource?.languageAPI)?.newProduct || "New products"}
            linkSlider={"/new-product"}
            myStyles={myStyles}
            showB={showB}
        />
    )

};

export default NewProduct;
